import React from "react"
import { Box } from "@mui/material"


export default function AppLabelValueBlock({ label, value, sxLabel, sxContainer }) {
	return <Box sx={{  display: 'flex', gap: .5, alignItems: 'flex-end', ...sxContainer  }}>
		<Box component='span' sx={{  color: 'text.disabled', mr: 0.5, ...sxLabel  }}>
			{label}:
		</Box>
		{value}
	</Box>
}